import React from 'react';

// Colour the overall score: green = good, amber = okay, red = weak.
export const scoreColor = (score) => {
  if (score >= 80) return 'text-green-600';
  if (score >= 60) return 'text-amber-600';
  return 'text-red-600';
};

// Colour a single word by how Azure rated it.
// Omission = word not said, Insertion = extra word; otherwise colour by accuracy.
const wordClass = (w) => {
  if (w.error_type === 'Omission') return 'text-gray-400 line-through';
  if (w.error_type === 'Insertion') return 'text-orange-400 italic underline decoration-dotted';
  if (w.accuracy >= 80) return 'text-green-600';
  if (w.accuracy >= 60) return 'text-amber-600';
  return 'text-red-600';
};

// Words of one assessed recording, coloured by Azure's per-word rating.
// Hover a word to see its exact score.
const PronunciationWords = ({ words, className = 'text-base' }) => {
  if (!words || words.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-x-2 gap-y-1 ${className}`}>
      {words.map((w, i) => (
        <span
          key={i}
          className={`font-medium ${wordClass(w)}`}
          title={`${Math.round(w.accuracy)} / 100 · ${w.error_type}`}
        >
          {w.word}
        </span>
      ))}
    </div>
  );
};

export default PronunciationWords;
